import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <p className="footer__text">
                {' '}
                <a
                    href="https://github.com/Caleb335"
                    className="link__text__white"
                >
                    seven {' '}
                </a>
                ©2020
            </p>
        </div>
    )
}

export default Footer
